export default "__VITE_ASSET__CKK_MDp2__"